 import React, { useState, useEffect } from 'react';
 import { useSelector, useDispatch } from 'react-redux'
 import { useNavigate, NavLink } from 'react-router-dom'
 import { toast } from 'react-toastify'
 import { Form, Button, Row, Col, InputGroup, Container } from 'react-bootstrap';
 import { FaGoogle, FaFacebookF, FaEnvelope, FaLock, FaEye, FaEyeSlash, FaShieldAlt } from 'react-icons/fa';
 import { login, reset } from '../features/auth/authSlice'
 import Spinner from '../components/utils/Spinner'
 import { toggleMenu, closeMenu } from '../features/utils/menuSlice';
 import '../styles/authShared.css';
 
 const Login = ({ onLogin }) => {
    const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const { email, password } = formData

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  )

  const menuState = useSelector((state) => state.menuShow.value);

  useEffect(() => {
    if (isError) {
      toast.error(message)
    }

    if (isSuccess || user) {
      navigate('/')
    }

    dispatch(reset())
  }, [user, isError, isSuccess, message, navigate, dispatch])

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  const onSubmit = (e) => {
    e.preventDefault()
    // Validate form data
    if (!email || !password) {
      toast.error('Please fill in all fields')
      return
    }

    const userData = {
      email,
      password,
    }

    // if (menuState) dispatch(toggleMenu());
    dispatch(login(userData))
  }

   const [showPassword, setShowPassword] = useState(false);
 
   const togglePasswordVisibility = () => {
     setShowPassword(!showPassword);
   };

  if (isLoading) {
    return <Spinner />
  }
 
   return (
     <Container className="d-flex align-items-center justify-content-center full-height">
       <div className="auth-card  card border-0 shadow-lg p-4">
         <div className="card-body p-4 p-md-5">
           {/* Header */}
           <div className="text-center mb-4">
             <h1 className="display-5 fw-bold mb-2 text-dark">Welcome Back</h1>
             <p className="text-muted">Sign in to your financial atelier.</p>
           </div>
 
           {/* Social Login */}
          {/* Social Login */}
          <Row className="g-3 mb-4 auth-social-section">
            <Col>
              <Button
                variant="outline-secondary"
                className="w-100 auth-social-btn d-flex align-items-center justify-content-center gap-2"
              >
                <FaGoogle className="auth-social-btn-google" />
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-secondary"
                className="w-100 auth-social-btn d-flex align-items-center justify-content-center gap-2"
              >
                <FaFacebookF className="auth-social-btn-facebook" />
              </Button>
            </Col>
          </Row>
 
           {/* Divider */}
           <div className="divider d-flex align-items-center my-4">
             <hr className="flex-grow-1" />
             <span className="px-3 small text-uppercase text-muted fw-bold">or continue with</span>
             <hr className="flex-grow-1" />
           </div>
 
           {/* Form */}
           <Form onSubmit={onSubmit}>
             {/* Corporate Email */}
             <div className="mb-4">
               <Form.Label className="fw-bold small text-uppercase mb-2">EMAIL</Form.Label>
                 <Form.Control
                   type="email"
                   placeholder="name@company.com"
                   className="bg-light"
                   value={email}
                   name="email"
                   autoComplete="email"
                   onChange={onChange}
                   required
                 />
             </div>
 
             {/* Secure Password */}
             <div className="mb-4">
               <div className="d-flex justify-content-between align-items-center mb-2">
                 <Form.Label className="fw-bold small text-uppercase mb-0">SECURE PASSWORD</Form.Label>
                 <a href="/forgot-password" className="small text-primary fw-bold">FORGOT?</a>
               </div>
               
               <InputGroup className='d-flex align-items-center'>
                 <Form.Control
                   type={showPassword ? "text" : "password"}
                   placeholder="••••••••"
                   className="bg-light"
                   value={password}
                   onChange={onChange}
                   name="password"
                   required
                 />
                 <InputGroup.Text 
                   className="bg-unset cursor-pointer me-1 h-75" 
                   onClick={togglePasswordVisibility}
                 >
                   {showPassword ? <FaEyeSlash className="text-muted" /> : <FaEye className="text-muted" />}
                 </InputGroup.Text>
               </InputGroup>
             </div>
 
             {/* Submit Button */}
             <div className="d-grid mb-4">
               <Button 
                 variant="primary" 
                 className="auth-btn-primary py-3 fw-bold shadow-sm btn btn-primary"
                 type="submit"
               >
                 Sign In to Dashboard
               </Button>
             </div>
           </Form>
 
           {/* Sign Up Link */}
           <div className="text-center mb-4">
             <span className="text-muted">New to the platform? </span>
             <a href="/register" className="fw-bold text-dark">Sign up</a>
           </div>

         </div>
       </div>
     </Container>
   );
 };
 
 export default Login;